module.exports = __webpack_public_path__ + "static/media/check-square.79504513.svg";